import Index from './index'
import Listar from './Listar'

const route = {
  path: '/mensagem-config',
  name: 'mensagem-config',
  component: Index,
  children: [
    { path: 'listar', name: 'mensagem-config-listar', component: Listar }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/mensagem-config/routes.js